import { useMemo } from 'react';
import { useGetAllLanguagesQuery } from '../../../api';

// Dil dropdown'u için ortak seçenek listesi hook'u.
const useLmsLanguageOptions = () => {
    const { data: languagesData, isLoading: isLoadingLanguages } = useGetAllLanguagesQuery();

    const languageOptions = useMemo(() => {
        const items = Array.isArray(languagesData) ? languagesData : [];
        return items.filter((item) => item && item.text).map((item) => ({ label: item.text, value: item.text }));
    }, [languagesData]);

    return { languageOptions, isLoadingLanguages };
};

export default useLmsLanguageOptions;
